<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS custom field details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Custom Field Detail</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CMSCustomFieldDetail">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSCustomFieldDetailList'}"><i class="fas fa-list"></i>
                  List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">


                  <div class="form-group ">
                    <label class="control-label">Field Label</label>
                    <input type="text" id="field_label" name="field_label"


                           v-model="value.field_label" class="form-control field_label"
                           placeholder="Field Label">

                  </div>
                  <div class="form-group ">
                    <label class="control-label">Field Type</label>
                    <select class="form-control" style="width: 100%;"
                            name="field_type" v-model="value.field_type" id="field_type">
                      <option value="Text">Text</option>
                      <option value="Textarea">Textarea</option>
                      <option value="Repeater">Repeater</option>
                    </select>

                  </div>


                  <div v-if="value.field_type == 'Text' || value.field_type == 'Textarea'">
                    <h4 class="site-heading my-3"><span>Fields Extras</span></h4>

                    <div class="form-row align-items-end">

                      <div class="form-group col-md-11 required">
                        <label class="control-label">Field Name</label>
                        <input type="text" id="fields_extra.field_name"
                               name="fields_extra.field_name"
                               v-bind:class="{'has-error' : errors.has('fields_extra.field_name')}"
                               v-validate="'required'"
                               v-model="value.fields_extras.field_name"
                               class="form-control fields_extra.field_label"
                               placeholder="Field Name">
                        <div class="help text-danger" v-show="errors.has('fields_extra.field_name')">
                          {{ errors.first("fields_extra.field_name") }}
                        </div>
                      </div>

                      <div class="form-group col-md-11 required">
                        <label class="control-label">Field Label</label>
                        <input type="text" id="cms_custom_field_detail.field_label"
                               name="cms_custom_field_detail.field_label"
                               v-bind:class="{'has-error' : errors.has('cms_custom_field_detail.field_label')}"
                               v-validate="'required'"
                               v-model="value.fields_extras.field_label"
                               class="form-control cms_custom_field_detail.field_label"
                               placeholder="Field Label">
                        <div class="help text-danger" v-show="errors.has('cms_custom_field_detail.field_label')">
                          {{ errors.first("cms_custom_field_detail.field_label") }}
                        </div>
                      </div>
                      <div class="clearfix"></div>
                      <div class="col-12">
                        <hr class="dotted">
                      </div>

                    </div>
                  </div>

                  <div class="offset-0 col-12" v-else-if="value.field_type == 'Repeater'">
                    <h4 class="site-heading my-3"><span>Fields</span></h4>


                    <table class="table">
                      <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Field Label</th>
                        <th>Field Type</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody class="has-many-student_detail-forms">

                      <tr class="has-many-student_detail-form fields-group"
                          v-for="(table_option, i) in value.fields_extras_additional">

                        <td>
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="table_option.field_name"
                                   placeholder="Field Name">
                          </div>
                        </td>
                        <td>
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="table_option.field_label"
                                   placeholder="Field Label">
                          </div>
                        </td>
                        <td>
                          <div class="form-group">
                            <select class="form-control fields_extras_additional" v-model="table_option.field_type" name="table_option.field_type">
                              <option value="Text" selected="selected">Text</option>
                              <option value="Textarea">Textarea</option>
                              <option value="Richtext">Richtext</option>
                            </select>
                          </div>
                        </td>

                        <td class="form-group">
                          <button type="button" class="btn btn-danger btn-sm float-right"
                                  @click="delete_fields_extras_additional(i)"><i
                            class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>


                      </tbody>
                    </table>

                    <button type="button" @click="add_fields_extras_additional()" class="btn btn-success btn-sm mt-3"><i
                      class="fa fa-plus"></i> New
                    </button>
                  </div>

                </div>
              </div>
            </div>
<!--            <span><pre>{{ value }}</pre></span>-->
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSCustomFieldDetailForm",
  metaInfo: {
    title: "CMS custom field details | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      fields_extras: {},
      fields_extras_additional: [],
    },
    pre: {}
  }),
  methods: {

    add_fields_extras: function () {
      this.value.fields_extras.push({});
    },

    add_fields_extras_additional: function () {
      this.value.fields_extras_additional.push({});
    },

    delete_fields_extras: function (index) {
      this.value.fields_extras.splice(index, 1)
    },
    delete_fields_extras_additional: function (index) {
      this.value.fields_extras_additional.splice(index, 1)
    },


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_custom_field_details";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_custom_field_details/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CMSCustomFieldDetailList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_custom_field_details/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

